<div class="game-effectiveness-container">
    <div *ngIf="isLoading || isLoadingGameParams"  class="loader-overlay">
        <cv-loader [loaderType]="'auto'" [size]="'medium'" [overlay]="false" [isFullScreen]="false"></cv-loader>
    </div>

    <div class="header">
        <h2 cvLocalizedText langSection="Game_Health_Report" langKey="Game_Effectiveness">Game Effectiveness</h2>
    </div>

    <div class="effectiveness-container" [class.blurred]="isLoading || isLoadingGameParams">
        <div class="canvas-container position-relative">
            <canvas *ngIf="!isLoading" baseChart  class="chart-effectiveness-container"
                [type]="chartType" 
                [data]="chartData" 
                [options]="chartOptions">
            </canvas>
        </div>
        <div class="stats-container">
            <div class="metric-selector" *ngIf="metricList.length > 1">
                <ng-container *ngIf="metricList.length > 1">
                    <select class="form-control select-rounds w-full mb-2" [disabled]="isLoading"
                        [(ngModel)]="gameMetric" (ngModelChange)="onMetricSelectionChange()">
                        <option *ngFor="let option of metricList" [ngValue]="option">{{ option.MetricDetail.Abbrev }}
                        </option>
                    </select>
                </ng-container>
            </div>
            <h2 *ngIf="gameMetric" class="title">{{ gameMetric.MetricDetail?.Abbrev }}</h2>
            <div *ngIf="gameMetric">
                <h3 cvLocalizedText langSection="Game_Health_Report" langKey="Metric_Direction" class="period-title">
                    Metric Direction</h3>
                <p class="date">{{ metricDirection }}</p>
            </div>
            <div class="period-section">
                <h3 cvLocalizedText langSection="Game_Health_Report" langKey="Game_Period" class="period-title">Game
                    Period</h3>
                <p class="date">{{ gamePeriod }}</p>
                <p class="average">
                    <span cvLocalizedText langSection="Game_Health_Report" langKey="Average">Avg. </span>
                    {{ formattedGamePeriodAvg }}
                    <span [class]="getStyleClass()">{{ calculateDifference() }}</span>
                </p>
            </div>
            <div class="period-section">
                <h3 cvLocalizedText langSection="Game_Health_Report" langKey="Previous_Period" class="period-title">
                    Previous Period</h3>
                <p class="date">{{ previousPeriod }}</p>
                <p class="average">
                    <span cvLocalizedText langSection="Game_Health_Report" langKey="Average">Avg. </span>
                    {{ formattedPreviousPeriodAvg }}
                </p>
            </div>
        </div>
    </div>
</div>